import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import fr from './locales/fr.json'
import en from './locales/en.json'

const resources = {
  fr: { translation: fr },
  en: { translation: en },
}

// Keep <html lang> in sync with the active language for a11y/SEO tooling and
// for components that read document.documentElement.lang.
const syncHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined' && document.documentElement && lng) {
    document.documentElement.lang = lng.split('-')[0]
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Reuse the cabinet's existing localStorage key so the value the old
      // (dead) FR/EN pill already persisted carries over transparently.
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'sgrc-language',
      caches: ['localStorage'],
    },
  })
  .then(() => syncHtmlLang(i18n.language))

syncHtmlLang(i18n.language)
i18n.on('languageChanged', syncHtmlLang)

export default i18n
